import type { PageLoad } from "./$types";
import { request } from "../../../data/client";
import { parseId } from "../../../params/slug";
import { GetMap } from "../../../data/schema";

export const load: PageLoad = async function ({ fetch, params, url, parent }) {
  const { map } = await request(fetch, {
    url,
    query: GetMap,
    variables: {
      id: parseId(params.id)
    }
  });

  const { places } = await parent();

  return {
    map,
    places: places,
    pageTheme: map.backgroundColor,
    pageTitle: map.title
  };
};
